import { render, staticRenderFns } from "./DialogPhotos.vue?vue&type=template&id=1b9c0dc1&scoped=true"
import script from "./DialogPhotos.vue?vue&type=script&lang=js"
export * from "./DialogPhotos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9c0dc1",
  null
  
)

export default component.exports